exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._19e5Ef5aBGKbIg-cIwmYZJ{color:white;display:inline-block;padding:2px 8px;margin:-2px 0;border-radius:3px}._2TBVwjrGBhEx46UxEMWyB8{background:#999}._2-Kv-YIz9T8Z7k1RfiJarQ{margin:0 0 0 10px;padding:0 6px;background:#fa6400}\n", ""]);

// Exports
exports.locals = {
	"Badge": "_19e5Ef5aBGKbIg-cIwmYZJ",
	"default": "_2TBVwjrGBhEx46UxEMWyB8",
	"commentAdmin": "_2-Kv-YIz9T8Z7k1RfiJarQ"
};